export { default } from './GooglePay';
